// 数字卡片盒子
<template>
  <div class="number-card-wrapper">
    <template v-for="(item, index) in _numArr">
      <number-card :value="+item" :key="index" :delay="index" />
    </template>
  </div>
</template>

<script>
import NumberCard from "@/components/number-card";

export default {
  components: {
    NumberCard,
  },
  props: {
    // 数值
    num: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    _numArr() {
      return this.num.toString().split("");
    },
  },
};
</script>

<style lang="scss" scoped>
.number-card-wrapper {
  display: flex;
}
</style>
